const SELECTOR_PROGRESS_BAR = ".js-lessons-progress-bar";

export default function setupUserProgress(list) {
  list = JSON.parse(list);

  // Add progress for progress bars
  const percentages = list.map((item) => {
    return {
      lessonId: item.lesson_id,
      percentage: item.completed_percentage / 100,
    };
  });

  $(SELECTOR_PROGRESS_BAR).each((ind, progressBar) => {
    const currentId = $(progressBar).attr("data-lesson-id");
    const percentage = percentages.filter(
      (person) => person.lessonId == currentId
    );
    const progressBarElement = $(progressBar)[0];

    if (percentage.length) {
      progressBarElement.style.setProperty(
        "--progress-bar-width",
        `${percentage[0].percentage}%`
      );
    }
  });
}
